import { render } from "./forgot_password.vue?vue&type=template&id=faefeba0"
import script from "./forgot_password.vue?vue&type=script&lang=js"
export * from "./forgot_password.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__